 const bariatricRecipes = [
            {
                id: 1,
                title: "Protein-Packed Chicken & Vegetable Puree",
                mealType: "lunch",
                prepTime: "medium",
                servings: 4,
                protein: 18,
                calories: 145,
                carbs: 8,
                mainIngredient: "chicken",
                description: "Excellent lean protein source with easily digestible vegetables. The smooth texture prevents irritation while delivering essential amino acids for healing. Low in fat to minimize dumping syndrome risk.",
                ingredients: [
                    "4 oz cooked chicken breast, boneless",
                    "1/2 cup cooked carrots",
                    "1/4 cup cooked green beans",
                    "2 tbsp low-sodium chicken broth",
                    "1 tsp olive oil",
                    "Pinch of garlic powder",
                    "Salt and pepper to taste"
                ],
                instructions: [
                    "Ensure chicken is fully cooked and cooled slightly",
                    "Steam carrots and green beans until very soft",
                    "Place all ingredients in a food processor",
                    "Process until completely smooth, adding broth as needed",
                    "Check consistency - should be smooth with no lumps",
                    "Serve immediately or store in refrigerator for up to 3 days"
                ]
            },
            {
                id: 2,
                title: "Vanilla Protein Pudding",
                mealType: "snack",
                prepTime: "quick",
                servings: 2,
                protein: 20,
                calories: 120,
                carbs: 6,
                mainIngredient: "protein-powder",
                description: "High-quality complete protein in an easily digestible form. Sugar-free to prevent dumping syndrome, with probiotics from Greek yogurt to support gut health during recovery.",
                ingredients: [
                    "1 scoop vanilla protein powder",
                    "1/2 cup unsweetened almond milk",
                    "2 tbsp sugar-free vanilla pudding mix",
                    "1 tsp vanilla extract",
                    "1/4 cup Greek yogurt, plain",
                    "Cinnamon to taste"
                ],
                instructions: [
                    "In a bowl, whisk protein powder with almond milk until smooth",
                    "Add pudding mix and whisk until no lumps remain",
                    "Blend in Greek yogurt and vanilla extract",
                    "Mix until completely smooth and creamy",
                    "Refrigerate for 15 minutes to thicken",
                    "Sprinkle with cinnamon before serving"
                ]
            },
            {
                id: 3,
                title: "Salmon & Sweet Potato Puree",
                mealType: "dinner",
                prepTime: "medium",
                servings: 3,
                protein: 22,
                calories: 165,
                carbs: 12,
                mainIngredient: "fish",
                description: "Omega-3 rich fish provides anti-inflammatory benefits for healing. Sweet potato offers beta-carotene and fiber, while the smooth texture ensures easy digestion and absorption.",
                ingredients: [
                    "4 oz cooked salmon fillet",
                    "1/2 cup cooked sweet potato",
                    "2 tbsp low-fat milk",
                    "1 tsp butter",
                    "1 tbsp fresh dill, chopped",
                    "Lemon juice to taste",
                    "Salt and white pepper"
                ],
                instructions: [
                    "Bake salmon until flaky and fully cooked",
                    "Steam sweet potato until very tender",
                    "Remove any skin or bones from salmon",
                    "Combine salmon and sweet potato in food processor",
                    "Add milk, butter, and seasonings",
                    "Process until smooth and creamy",
                    "Adjust consistency with additional milk if needed"
                ]
            },
            {
                id: 4,
                title: "Cottage Cheese & Fruit Breakfast",
                mealType: "breakfast",
                prepTime: "quick",
                servings: 1,
                protein: 16,
                calories: 110,
                carbs: 10,
                mainIngredient: "cottage-cheese",
                description: "High in casein protein for sustained amino acid release. The calcium supports bone health, while natural fruit provides vitamins without added sugars that could trigger dumping syndrome.",
                ingredients: [
                    "1/2 cup low-fat cottage cheese",
                    "1/4 cup canned peaches in juice, drained",
                    "1 tbsp unsweetened applesauce",
                    "1 tsp honey (optional)",
                    "Pinch of cinnamon",
                    "1 tsp vanilla extract"
                ],
                instructions: [
                    "Drain peaches thoroughly and check for any pieces",
                    "Place cottage cheese in food processor",
                    "Add peaches, applesauce, and vanilla",
                    "Process until completely smooth",
                    "Add honey if desired sweetness",
                    "Sprinkle with cinnamon and serve immediately"
                ]
            },
            {
                id: 5,
                title: "Turkey & Avocado Protein Puree",
                mealType: "lunch",
                prepTime: "quick",
                servings: 2,
                protein: 19,
                calories: 155,
                carbs: 5,
                mainIngredient: "turkey",
                description: "Lean turkey provides high-quality protein while avocado adds healthy monounsaturated fats and fiber. The creamy texture requires minimal chewing and is gentle on the healing stomach.",
                ingredients: [
                    "3 oz cooked ground turkey, lean",
                    "1/4 ripe avocado",
                    "2 tbsp low-sodium chicken broth",
                    "1 tbsp plain Greek yogurt",
                    "1 tsp lime juice",
                    "Pinch of cumin",
                    "Salt and pepper to taste"
                ],
                instructions: [
                    "Cook ground turkey thoroughly and let cool",
                    "Remove pit and skin from avocado",
                    "Combine turkey and avocado in food processor",
                    "Add broth, yogurt, and seasonings",
                    "Process until completely smooth",
                    "Add more broth if needed for desired consistency",
                    "Taste and adjust seasoning"
                ]
            },
            {
                id: 6,
                title: "Chocolate Protein Mousse",
                mealType: "snack",
                prepTime: "quick",
                servings: 2,
                protein: 17,
                calories: 95,
                carbs: 8,
                mainIngredient: "protein-powder",
                description: "Satisfies chocolate cravings without sugar spikes. High protein content supports muscle preservation, while the light, airy texture is easy to digest and won't cause discomfort.",
                ingredients: [
                    "1 scoop chocolate protein powder",
                    "1/2 cup unsweetened cocoa powder",
                    "1/2 cup Greek yogurt, plain",
                    "3 tbsp unsweetened almond milk",
                    "1 tsp vanilla extract",
                    "1 packet stevia or to taste"
                ],
                instructions: [
                    "In a bowl, mix protein powder with almond milk",
                    "Whisk until no lumps remain",
                    "Add Greek yogurt and vanilla extract",
                    "Blend in cocoa powder gradually",
                    "Sweeten with stevia to taste",
                    "Whip until light and fluffy",
                    "Chill for 30 minutes before serving"
                ]
            },
            {
                id: 7,
                title: "Beef & Carrot Dinner Puree",
                mealType: "dinner",
                prepTime: "medium",
                servings: 4,
                protein: 21,
                calories: 140,
                carbs: 7,
                mainIngredient: "beef",
                description: "Rich in iron and B vitamins, crucial for preventing post-surgery anemia. The lean beef provides complete proteins, while carrots add beta-carotene and natural sweetness.",
                ingredients: [
                    "4 oz lean ground beef, cooked",
                    "1/2 cup cooked carrots",
                    "1/4 cup cooked potatoes",
                    "3 tbsp beef broth, low-sodium",
                    "1 tsp olive oil",
                    "Herbs (thyme, rosemary)",
                    "Salt and pepper"
                ],
                instructions: [
                    "Brown ground beef thoroughly, drain fat",
                    "Steam carrots and potatoes until very soft",
                    "Let all ingredients cool slightly",
                    "Combine in food processor with broth",
                    "Add herbs and seasonings",
                    "Process until completely smooth",
                    "Add more broth if needed for consistency"
                ]
            },
            {
                id: 8,
                title: "Banana Protein Breakfast Smoothie",
                mealType: "breakfast",
                prepTime: "quick",
                servings: 1,
                protein: 15,
                calories: 125,
                carbs: 18,
                mainIngredient: "banana",
                description: "Potassium-rich banana supports heart health and muscle function. The natural sugars provide quick energy, while protein powder ensures adequate protein intake in a small, manageable portion.",
                ingredients: [
                    "1/2 ripe banana",
                    "1 scoop vanilla protein powder",
                    "1/2 cup unsweetened almond milk",
                    "2 tbsp Greek yogurt",
                    "1 tsp almond butter",
                    "Pinch of cinnamon",
                    "Ice cubes as needed"
                ],
                instructions: [
                    "Peel and slice banana",
                    "Add all ingredients to blender",
                    "Blend until completely smooth",
                    "Check consistency - should be thick but pourable",
                    "Add ice or more milk to adjust",
                    "Blend again until no lumps remain",
                    "Serve immediately"
                ]
            },
            {
                id: 9,
                title: "Creamy Chicken & Spinach Puree",
                mealType: "dinner",
                prepTime: "medium",
                servings: 3,
                protein: 20,
                calories: 135,
                carbs: 4,
                mainIngredient: "chicken",
                description: "Iron-rich spinach helps prevent anemia common after bariatric surgery. The combination provides folate, vitamin K, and high-quality protein in an easily digestible form.",
                ingredients: [
                    "4 oz cooked chicken thigh, skinless",
                    "1 cup fresh spinach, steamed",
                    "2 tbsp cream cheese, low-fat",
                    "3 tbsp chicken broth",
                    "1 clove garlic, minced",
                    "1 tsp olive oil",
                    "Nutmeg and pepper to taste"
                ],
                instructions: [
                    "Cook chicken thoroughly and let cool",
                    "Steam spinach until wilted and soft",
                    "Sauté garlic in olive oil until fragrant",
                    "Combine all ingredients in food processor",
                    "Process until completely smooth",
                    "Add more broth for desired consistency",
                    "Season with nutmeg and pepper"
                ]
            },
            {
                id: 10,
                title: "Tuna & White Bean Protein Puree",
                mealType: "lunch",
                prepTime: "quick",
                servings: 2,
                protein: 24,
                calories: 180,
                carbs: 12,
                mainIngredient: "fish",
                description: "Double protein source combining fish and legumes. Rich in omega-3s and fiber, this combination supports heart health and provides sustained energy without blood sugar spikes.",
                ingredients: [
                    "1 can tuna in water, drained",
                    "1/2 cup cooked white beans",
                    "2 tbsp olive oil",
                    "1 tbsp lemon juice",
                    "2 tbsp Greek yogurt",
                    "1 tsp dried herbs",
                    "Salt and pepper"
                ],
                instructions: [
                    "Drain tuna thoroughly",
                    "Rinse and drain white beans",
                    "Combine tuna and beans in food processor",
                    "Add olive oil, lemon juice, and yogurt",
                    "Process until smooth and creamy",
                    "Season with herbs, salt, and pepper",
                    "Adjust consistency with water if needed"
                ]
            },
            {
                id: 11,
                title: "Scrambled Egg & Cheese Puree",
                mealType: "breakfast",
                prepTime: "quick",
                servings: 1,
                protein: 18,
                calories: 165,
                carbs: 2,
                mainIngredient: "eggs",
                description: "Complete protein with all essential amino acids. Easy to digest and rich in choline for brain health. The smooth texture makes it ideal for sensitive stomachs during recovery.",
                ingredients: [
                    "2 large eggs",
                    "2 tbsp low-fat milk",
                    "2 tbsp shredded cheese, mild",
                    "1 tsp butter",
                    "1 tbsp cream cheese",
                    "Chives for garnish",
                    "Salt and pepper"
                ],
                instructions: [
                    "Scramble eggs with milk until very soft",
                    "Add cheese while eggs are still hot",
                    "Let cool slightly, then transfer to blender",
                    "Add cream cheese and butter",
                    "Blend until completely smooth",
                    "Season to taste",
                    "Garnish with chopped chives"
                ]
            },
            {
                id: 12,
                title: "Greek Yogurt Berry Parfait Puree",
                mealType: "snack",
                prepTime: "quick",
                servings: 1,
                protein: 16,
                calories: 140,
                carbs: 15,
                mainIngredient: "yogurt",
                description: "Probiotics support gut health during recovery. Antioxidant-rich berries provide vitamin C for healing, while the protein helps maintain muscle mass during weight loss.",
                ingredients: [
                    "3/4 cup Greek yogurt, plain",
                    "1/4 cup mixed berries, fresh or frozen",
                    "1 tbsp honey",
                    "1 tsp vanilla extract",
                    "1 tbsp ground flaxseed",
                    "Cinnamon to taste"
                ],
                instructions: [
                    "If using frozen berries, thaw completely",
                    "Combine yogurt and vanilla in bowl",
                    "Add berries and honey",
                    "Blend with immersion blender until smooth",
                    "Stir in ground flaxseed",
                    "Sprinkle with cinnamon",
                    "Chill before serving"
                ]
            },
            {
                id: 13,
                title: "Turkey Meatball Puree",
                mealType: "dinner",
                prepTime: "medium",
                servings: 4,
                protein: 23,
                calories: 155,
                carbs: 6,
                mainIngredient: "turkey",
                description: "Lean protein with added vegetables increases nutrient density. The pureed form ensures easy digestion while maintaining the comfort food appeal that aids psychological adjustment.",
                ingredients: [
                    "6 oz ground turkey, extra lean",
                    "1 egg white",
                    "2 tbsp breadcrumbs, fine",
                    "1/4 cup cooked zucchini",
                    "3 tbsp turkey broth",
                    "1 tsp Italian seasoning",
                    "Salt and pepper"
                ],
                instructions: [
                    "Mix turkey, egg white, and breadcrumbs",
                    "Form into small meatballs and bake at 375°F",
                    "Cook until internal temp reaches 165°F",
                    "Steam zucchini until very soft",
                    "Combine meatballs and zucchini in processor",
                    "Add broth and seasonings",
                    "Process until completely smooth"
                ]
            },
            {
                id: 14,
                title: "Sweet Potato & Black Bean Puree",
                mealType: "lunch",
                prepTime: "medium",
                servings: 3,
                protein: 12,
                calories: 145,
                carbs: 25,
                mainIngredient: "sweet-potato",
                description: "Plant-based protein with complex carbohydrates for sustained energy. Rich in fiber and beta-carotene, supporting digestive health and immune function during recovery.",
                ingredients: [
                    "1 large cooked sweet potato",
                    "1/2 cup cooked black beans",
                    "2 tbsp vegetable broth",
                    "1 tbsp lime juice",
                    "1/2 tsp cumin",
                    "1/4 tsp chili powder",
                    "Salt to taste"
                ],
                instructions: [
                    "Bake sweet potato until very tender",
                    "Remove skin and mash flesh",
                    "Rinse and drain black beans",
                    "Combine sweet potato and beans in processor",
                    "Add broth, lime juice, and spices",
                    "Process until smooth and creamy",
                    "Add more broth if needed"
                ]
            },
            {
                id: 15,
                title: "Silken Tofu Chocolate Mousse",
                mealType: "snack",
                prepTime: "quick",
                servings: 2,
                protein: 14,
                calories: 120,
                carbs: 10,
                mainIngredient: "tofu",
                description: "Plant-based complete protein with isoflavones for hormonal balance. Low in saturated fat and cholesterol-free, making it heart-healthy during weight loss.",
                ingredients: [
                    "6 oz silken tofu",
                    "2 tbsp unsweetened cocoa powder",
                    "2 tbsp maple syrup",
                    "1 tsp vanilla extract",
                    "1 tbsp almond butter",
                    "Pinch of salt",
                    "Dark chocolate shavings (optional)"
                ],
                instructions: [
                    "Drain tofu and pat dry",
                    "Combine all ingredients in blender",
                    "Blend until completely smooth",
                    "Taste and adjust sweetness",
                    "Refrigerate for 30 minutes",
                    "Serve chilled",
                    "Garnish with chocolate shavings if desired"
                ]
            },
            {
                id: 16,
                title: "Cottage Cheese Pancake Puree",
                mealType: "breakfast",
                prepTime: "medium",
                servings: 2,
                protein: 22,
                calories: 175,
                carbs: 8,
                mainIngredient: "cottage-cheese",
                description: "High protein breakfast that satisfies pancake cravings without the carb overload. The combination provides slow-digesting protein to keep you full longer on small portions.",
                ingredients: [
                    "1/2 cup cottage cheese",
                    "2 large eggs",
                    "2 tbsp oat flour",
                    "1 tbsp vanilla extract",
                    "1 tsp cinnamon",
                    "Sugar-free syrup",
                    "Cooking spray"
                ],
                instructions: [
                    "Blend cottage cheese, eggs, and oat flour",
                    "Add vanilla and cinnamon",
                    "Cook small pancakes in non-stick pan",
                    "Cook until golden and set through",
                    "Let cool, then puree pancakes",
                    "Add syrup while blending",
                    "Serve warm or at room temperature"
                ]
            },
            {
                id: 17,
                title: "Lentil & Carrot Protein Puree",
                mealType: "dinner",
                prepTime: "medium",
                servings: 4,
                protein: 16,
                calories: 160,
                carbs: 22,
                mainIngredient: "beans",
                description: "Plant-based protein with folate essential for cell regeneration. The fiber supports healthy digestion while the smooth texture prevents any gastric irritation.",
                ingredients: [
                    "3/4 cup cooked red lentils",
                    "1/2 cup cooked carrots",
                    "1/4 cup vegetable broth",
                    "1 tbsp olive oil",
                    "1 tsp curry powder",
                    "1/2 tsp turmeric",
                    "Salt and pepper"
                ],
                instructions: [
                    "Cook lentils until very soft",
                    "Steam carrots until tender",
                    "Combine lentils and carrots in processor",
                    "Add broth, oil, and spices",
                    "Process until completely smooth",
                    "Season with salt and pepper",
                    "Add more broth for desired consistency"
                ]
            },
            {
                id: 18,
                title: "Avocado & Spinach Green Smoothie",
                mealType: "snack",
                prepTime: "quick",
                servings: 1,
                protein: 8,
                calories: 185,
                carbs: 12,
                mainIngredient: "avocado",
                description: "Nutrient-dense green smoothie packed with folate and healthy fats. The creamy texture disguises vegetables while providing essential nutrients for healing and energy.",
                ingredients: [
                    "1/2 ripe avocado",
                    "1 cup fresh spinach",
                    "1/2 cup unsweetened almond milk",
                    "1 scoop vanilla protein powder",
                    "1 tbsp lime juice",
                    "1 tsp honey",
                    "Ice cubes"
                ],
                instructions: [
                    "Remove avocado pit and skin",
                    "Wash spinach thoroughly",
                    "Add all ingredients to blender",
                    "Blend until completely smooth",
                    "Add ice for desired thickness",
                    "Taste and adjust sweetness",
                    "Serve immediately"
                ]
            },
            {
                id: 19,
                title: "Strawberry Banana Protein Smoothie",
                mealType: "breakfast",
                prepTime: "quick",
                servings: 1,
                protein: 18,
                calories: 155,
                carbs: 20,
                mainIngredient: "berries",
                description: "Vitamin C from strawberries supports collagen synthesis for wound healing. Natural fruit sugars provide energy without overwhelming the reduced stomach capacity.",
                ingredients: [
                    "1/2 cup fresh strawberries",
                    "1/2 ripe banana",
                    "1 scoop vanilla protein powder",
                    "1/2 cup unsweetened almond milk",
                    "2 tbsp Greek yogurt",
                    "1 tsp vanilla extract",
                    "Ice as needed"
                ],
                instructions: [
                    "Hull and wash strawberries",
                    "Peel and slice banana",
                    "Add all ingredients to blender",
                    "Blend until completely smooth",
                    "Check consistency and add ice if needed",
                    "Blend again until no lumps remain",
                    "Serve immediately"
                ]
            },
            {
                id: 20,
                title: "Cod & Cauliflower Puree",
                mealType: "dinner",
                prepTime: "medium",
                servings: 3,
                protein: 20,
                calories: 125,
                carbs: 6,
                mainIngredient: "fish",
                description: "Mild white fish is gentle on sensitive stomachs while providing high-quality protein. Cauliflower adds vitamins C and K without excess calories or carbohydrates.",
                ingredients: [
                    "4 oz cooked cod fillet",
                    "1/2 cup cooked cauliflower",
                    "2 tbsp low-fat milk",
                    "1 tbsp butter",
                    "1 tsp lemon juice",
                    "Fresh parsley",
                    "Salt and white pepper"
                ],
                instructions: [
                    "Bake cod until flaky and fully cooked",
                    "Steam cauliflower until very tender",
                    "Remove any bones from cod",
                    "Combine cod and cauliflower in processor",
                    "Add milk, butter, and lemon juice",
                    "Process until smooth and creamy",
                    "Garnish with fresh parsley"
                ]
            },
            {
                id: 21,
                title: "Peanut Butter Protein Power Smoothie",
                mealType: "snack",
                prepTime: "quick",
                servings: 1,
                protein: 25,
                calories: 220,
                carbs: 8,
                mainIngredient: "protein-powder",
                description: "Maximum protein density for muscle preservation during rapid weight loss. Healthy fats from peanut butter slow digestion and provide satisfaction in small portions.",
                ingredients: [
                    "1 scoop chocolate protein powder",
                    "1 tbsp natural peanut butter",
                    "1/2 cup unsweetened almond milk",
                    "1/4 cup Greek yogurt",
                    "1 tsp vanilla extract",
                    "Stevia to taste",
                    "Ice cubes"
                ],
                instructions: [
                    "Add protein powder and almond milk to blender",
                    "Blend until protein powder is dissolved",
                    "Add peanut butter and Greek yogurt",
                    "Add vanilla and stevia",
                    "Blend until completely smooth",
                    "Add ice for desired consistency",
                    "Serve immediately"
                ]
            },
            {
                id: 22,
                title: "Egg Salad Puree",
                mealType: "lunch",
                prepTime: "quick",
                servings: 2,
                protein: 14,
                calories: 145,
                carbs: 2,
                mainIngredient: "eggs",
                description: "Classic comfort food modified for puree stage. High in protein and choline, supporting brain health and muscle maintenance while being gentle on the healing digestive system.",
                ingredients: [
                    "3 hard-boiled eggs",
                    "2 tbsp light mayonnaise",
                    "1 tbsp Greek yogurt",
                    "1 tsp Dijon mustard",
                    "1 tbsp chives, chopped",
                    "Paprika",
                    "Salt and pepper"
                ],
                instructions: [
                    "Hard boil eggs and let cool completely",
                    "Peel eggs and remove any shell pieces",
                    "Place eggs in food processor",
                    "Add mayonnaise, yogurt, and mustard",
                    "Process until completely smooth",
                    "Stir in chives",
                    "Season with paprika, salt, and pepper"
                ]
            },
            {
                id: 23,
                title: "Blueberry Yogurt Protein Smoothie",
                mealType: "breakfast",
                prepTime: "quick",
                servings: 1,
                protein: 20,
                calories: 165,
                carbs: 18,
                mainIngredient: "berries",
                description: "Antioxidant powerhouse supporting immune function during recovery. Blueberries provide anthocyanins for inflammation reduction while protein supports tissue healing.",
                ingredients: [
                    "1/2 cup fresh or frozen blueberries",
                    "3/4 cup Greek yogurt, vanilla",
                    "1/2 scoop vanilla protein powder",
                    "1/4 cup unsweetened almond milk",
                    "1 tsp honey",
                    "1/2 tsp lemon zest",
                    "Ice if using fresh berries"
                ],
                instructions: [
                    "If using frozen berries, thaw slightly",
                    "Add yogurt and protein powder to blender",
                    "Add blueberries and almond milk",
                    "Add honey and lemon zest",
                    "Blend until completely smooth",
                    "Add ice if needed for consistency",
                    "Serve immediately"
                ]
            },
            {
                id: 24,
                title: "Turkey & Sweet Potato Hash Puree",
                mealType: "dinner",
                prepTime: "medium",
                servings: 4,
                protein: 19,
                calories: 165,
                carbs: 14,
                mainIngredient: "turkey",
                description: "Comfort food reimagined for bariatric patients. Provides sustained energy from complex carbs while delivering lean protein for muscle preservation during weight loss.",
                ingredients: [
                    "4 oz ground turkey, lean",
                    "1/2 cup cooked sweet potato, diced",
                    "1/4 cup onion, sautéed",
                    "2 tbsp turkey broth",
                    "1 tsp sage",
                    "1/2 tsp thyme",
                    "Salt and pepper"
                ],
                instructions: [
                    "Brown ground turkey thoroughly",
                    "Sauté onion until very soft",
                    "Roast sweet potato until tender",
                    "Combine all ingredients in processor",
                    "Add broth and herbs",
                    "Process until smooth",
                    "Season to taste"
                ]
            },
            {
                id: 25,
                title: "Spinach & Feta Protein Puree",
                mealType: "lunch",
                prepTime: "medium",
                servings: 2,
                protein: 15,
                calories: 130,
                carbs: 5,
                mainIngredient: "spinach",
                description: "Mediterranean flavors provide iron and calcium essential for post-surgery nutrition. The smooth texture makes nutrient absorption easy while satisfying savory cravings.",
                ingredients: [
                    "2 cups fresh spinach",
                    "1/4 cup feta cheese, crumbled",
                    "2 tbsp Greek yogurt",
                    "1 tbsp olive oil",
                    "1 clove garlic, minced",
                    "Lemon juice",
                    "Black pepper"
                ],
                instructions: [
                    "Steam spinach until wilted",
                    "Sauté garlic in olive oil",
                    "Combine spinach, feta, and garlic",
                    "Add Greek yogurt and lemon juice",
                    "Process until smooth",
                    "Season with pepper",
                    "Serve warm or cold"
                ]
            },
            {
                id: 26,
                title: "Ricotta & Vanilla Bean Pudding",
                mealType: "snack",
                prepTime: "quick",
                servings: 2,
                protein: 16,
                calories: 135,
                carbs: 8,
                mainIngredient: "cottage-cheese",
                description: "High-protein dessert that satisfies sweet cravings without added sugars. Ricotta provides calcium for bone health while the smooth texture is perfect for sensitive stomachs.",
                ingredients: [
                    "1/2 cup part-skim ricotta cheese",
                    "2 tbsp Greek yogurt",
                    "1 tsp vanilla bean paste",
                    "1 tbsp sugar-free maple syrup",
                    "1 tbsp almond flour",
                    "Cinnamon",
                    "Berries for garnish (optional)"
                ],
                instructions: [
                    "Combine ricotta and Greek yogurt in processor",
                    "Add vanilla bean paste and syrup",
                    "Process until completely smooth",
                    "Fold in almond flour",
                    "Divide into serving cups",
                    "Sprinkle with cinnamon",
                    "Chill for 30 minutes before serving"
                ]
            },
            {
                id: 27,
                title: "White Fish & Pea Puree",
                mealType: "dinner",
                prepTime: "medium",
                servings: 3,
                protein: 21,
                calories: 140,
                carbs: 8,
                mainIngredient: "fish",
                description: "Mild white fish provides easily digestible protein while green peas add fiber and plant protein. The combination supports digestive health during the healing phase.",
                ingredients: [
                    "4 oz cooked white fish (tilapia or sole)",
                    "1/2 cup cooked green peas",
                    "2 tbsp vegetable broth",
                    "1 tbsp olive oil",
                    "1 tsp fresh mint, chopped",
                    "Lemon zest",
                    "Salt and white pepper"
                ],
                instructions: [
                    "Cook fish until flaky and remove any bones",
                    "Steam peas until very tender",
                    "Combine fish and peas in processor",
                    "Add broth and olive oil",
                    "Process until smooth",
                    "Stir in mint and lemon zest",
                    "Season to taste"
                ]
            },
            {
                id: 28,
                title: "Mango Coconut Protein Smoothie",
                mealType: "breakfast",
                prepTime: "quick",
                servings: 1,
                protein: 17,
                calories: 150,
                carbs: 16,
                mainIngredient: "protein-powder",
                description: "Tropical flavors make nutrition enjoyable during recovery. Mango provides vitamin A for tissue repair, while coconut adds healthy medium-chain fats for energy.",
                ingredients: [
                    "1/2 cup frozen mango chunks",
                    "1 scoop vanilla protein powder",
                    "1/4 cup light coconut milk",
                    "1/4 cup Greek yogurt",
                    "1 tbsp lime juice",
                    "1 tsp honey",
                    "Ice as needed"
                ],
                instructions: [
                    "Thaw mango chunks slightly",
                    "Add protein powder and coconut milk to blender",
                    "Add mango and Greek yogurt",
                    "Add lime juice and honey",
                    "Blend until completely smooth",
                    "Add ice for desired consistency",
                    "Serve immediately"
                ]
            },
            {
                id: 29,
                title: "Cauliflower Mac & Cheese Puree",
                mealType: "lunch",
                prepTime: "medium",
                servings: 3,
                protein: 14,
                calories: 155,
                carbs: 9,
                mainIngredient: "cottage-cheese",
                description: "Comfort food favorite reimagined with extra protein and fewer carbs. Cauliflower provides fiber and vitamins while cheese adds calcium and familiar flavors.",
                ingredients: [
                    "1 cup cooked cauliflower",
                    "1/4 cup cottage cheese",
                    "2 tbsp cheddar cheese, shredded",
                    "2 tbsp Greek yogurt",
                    "1 tbsp milk",
                    "1/4 tsp garlic powder",
                    "Paprika and pepper"
                ],
                instructions: [
                    "Steam cauliflower until very tender",
                    "Combine with cottage cheese in processor",
                    "Add cheddar cheese while warm",
                    "Add yogurt, milk, and seasonings",
                    "Process until completely smooth",
                    "Adjust consistency with milk",
                    "Serve warm"
                ]
            },
            {
                id: 30,
                title: "Chickpea & Tahini Hummus Smoothie",
                mealType: "snack",
                prepTime: "quick",
                servings: 2,
                protein: 12,
                calories: 165,
                carbs: 18,
                mainIngredient: "beans",
                description: "Plant-based protein with healthy fats from tahini. Provides fiber for digestive health and complex carbohydrates for sustained energy in an easily digestible form.",
                ingredients: [
                    "1/2 cup cooked chickpeas",
                    "1 tbsp tahini",
                    "1/4 cup vegetable broth",
                    "1 tbsp lemon juice",
                    "1/2 tsp cumin",
                    "1 clove garlic, minced",
                    "Salt and pepper"
                ],
                instructions: [
                    "Ensure chickpeas are very soft",
                    "Combine all ingredients in blender",
                    "Blend until completely smooth",
                    "Add more broth for desired consistency",
                    "Taste and adjust seasonings",
                    "Serve at room temperature",
                    "Can be thinned further for drinking"
                ]
            },
            {
                id: 31,
                title: "Pork Tenderloin & Apple Puree",
                mealType: "dinner",
                prepTime: "medium",
                servings: 3,
                protein: 24,
                calories: 160,
                carbs: 12,
                mainIngredient: "beef",
                description: "Lean pork provides thiamine for nerve function and energy metabolism. Apples add fiber and natural sweetness while creating a smooth, appealing texture that's easy to digest.",
                ingredients: [
                    "4 oz cooked pork tenderloin",
                    "1/2 cup cooked apple, peeled",
                    "2 tbsp pork or chicken broth",
                    "1 tsp olive oil",
                    "1/2 tsp cinnamon",
                    "1/4 tsp sage",
                    "Salt and pepper"
                ],
                instructions: [
                    "Roast pork tenderloin until internal temp reaches 145°F",
                    "Steam peeled apple until very soft",
                    "Let pork rest and cool slightly",
                    "Combine pork and apple in food processor",
                    "Add broth, oil, and seasonings",
                    "Process until completely smooth",
                    "Adjust consistency with additional broth"
                ]
            },
            {
                id: 32,
                title: "Shrimp & Cauliflower Curry Puree",
                mealType: "lunch",
                prepTime: "medium",
                servings: 2,
                protein: 22,
                calories: 140,
                carbs: 8,
                mainIngredient: "fish",
                description: "Low-calorie, high-protein seafood with anti-inflammatory spices. Shrimp provides selenium for immune function, while cauliflower adds vitamin C for wound healing.",
                ingredients: [
                    "6 oz cooked shrimp, peeled",
                    "3/4 cup cooked cauliflower",
                    "3 tbsp coconut milk, light",
                    "1 tsp curry powder",
                    "1/2 tsp turmeric",
                    "1 tbsp lime juice",
                    "Salt to taste"
                ],
                instructions: [
                    "Cook shrimp until pink and opaque",
                    "Steam cauliflower until very tender",
                    "Combine shrimp and cauliflower in processor",
                    "Add coconut milk and spices",
                    "Process until smooth and creamy",
                    "Add lime juice and salt",
                    "Serve warm or at room temperature"
                ]
            },
            {
                id: 33,
                title: "Quinoa & Vegetable Protein Bowl",
                mealType: "lunch",
                prepTime: "medium",
                servings: 3,
                protein: 14,
                calories: 175,
                carbs: 28,
                mainIngredient: "beans",
                description: "Complete plant protein with all essential amino acids. Quinoa is easily digestible and provides iron, while mixed vegetables ensure vitamin and mineral diversity.",
                ingredients: [
                    "1/2 cup cooked quinoa",
                    "1/4 cup cooked broccoli",
                    "1/4 cup cooked carrots",
                    "2 tbsp vegetable broth",
                    "1 tbsp olive oil",
                    "1 tsp nutritional yeast",
                    "Herbs and seasonings"
                ],
                instructions: [
                    "Cook quinoa until very soft and fluffy",
                    "Steam vegetables until tender",
                    "Combine quinoa and vegetables in processor",
                    "Add broth, oil, and nutritional yeast",
                    "Process until smooth",
                    "Season with herbs",
                    "Add more broth for desired consistency"
                ]
            },
            {
                id: 34,
                title: "Chicken Liver Pâté Puree",
                mealType: "snack",
                prepTime: "medium",
                servings: 4,
                protein: 18,
                calories: 155,
                carbs: 3,
                mainIngredient: "chicken",
                description: "Exceptionally rich in iron and B vitamins, crucial for preventing post-surgery anemia and supporting energy metabolism. The smooth texture makes nutrients highly bioavailable.",
                ingredients: [
                    "4 oz chicken livers, cleaned",
                    "2 tbsp Greek yogurt",
                    "1 tbsp cream cheese, low-fat",
                    "2 tbsp chicken broth",
                    "1 tsp herbs de Provence",
                    "1 tsp olive oil",
                    "Salt and pepper"
                ],
                instructions: [
                    "Sauté chicken livers until cooked through",
                    "Let cool completely",
                    "Combine livers with yogurt and cream cheese",
                    "Add broth and seasonings",
                    "Process until completely smooth",
                    "Pass through fine sieve if needed",
                    "Chill before serving"
                ]
            },
            {
                id: 35,
                title: "Butternut Squash & Turkey Comfort Puree",
                mealType: "dinner",
                prepTime: "medium",
                servings: 4,
                protein: 20,
                calories: 150,
                carbs: 16,
                mainIngredient: "turkey",
                description: "Comfort food that supports emotional well-being during recovery. Beta-carotene from squash supports immune function, while lean turkey provides complete protein.",
                ingredients: [
                    "4 oz ground turkey, lean",
                    "3/4 cup roasted butternut squash",
                    "3 tbsp turkey broth",
                    "1 tbsp olive oil",
                    "1/2 tsp sage",
                    "1/4 tsp nutmeg",
                    "Salt and pepper"
                ],
                instructions: [
                    "Brown turkey thoroughly and drain",
                    "Roast butternut squash until very tender",
                    "Combine turkey and squash in processor",
                    "Add broth, oil, and seasonings",
                    "Process until smooth and creamy",
                    "Adjust consistency with more broth",
                    "Serve warm"
                ]
            },
            {
                id: 36,
                title: "Greek Yogurt Ranch Protein Dip",
                mealType: "snack",
                prepTime: "quick",
                servings: 2,
                protein: 12,
                calories: 85,
                carbs: 6,
                mainIngredient: "yogurt",
                description: "Familiar ranch flavor in a protein-packed form. Probiotics support digestive health during recovery, while herbs provide antioxidants and familiar comfort flavors.",
                ingredients: [
                    "3/4 cup Greek yogurt, plain",
                    "1 tbsp light mayonnaise",
                    "1 tsp dried dill",
                    "1/2 tsp garlic powder",
                    "1/2 tsp onion powder",
                    "1 tsp lemon juice",
                    "Salt and pepper"
                ],
                instructions: [
                    "Combine Greek yogurt and mayonnaise",
                    "Add all dried seasonings",
                    "Mix in lemon juice",
                    "Blend until completely smooth",
                    "Taste and adjust seasonings",
                    "Thin with water if needed",
                    "Chill for flavors to meld"
                ]
            },
            {
                id: 37,
                title: "Simple Canned Chicken Puree",
                mealType: "lunch",
                prepTime: "quick",
                servings: 2,
                protein: 20,
                calories: 130,
                carbs: 2,
                mainIngredient: "chicken",
                description: "Ultra-convenient protein option for busy days or low energy periods. Canned chicken is pre-cooked and tender, making it perfect for quick nutrition when fresh cooking isn't possible.",
                ingredients: [
                    "1 can (5 oz) chicken breast in water, drained",
                    "3 tbsp low-sodium chicken broth",
                    "1 tbsp Greek yogurt",
                    "1/2 tsp garlic powder",
                    "Salt and pepper to taste"
                ],
                instructions: [
                    "Drain canned chicken thoroughly",
                    "Place chicken in food processor",
                    "Add broth and Greek yogurt",
                    "Add seasonings",
                    "Process until completely smooth",
                    "Add more broth if needed for consistency"
                ]
            },
            {
                id: 38,
                title: "Basic Banana Pudding",
                mealType: "snack",
                prepTime: "quick",
                servings: 1,
                protein: 6,
                calories: 120,
                carbs: 22,
                mainIngredient: "banana",
                description: "Simple, naturally sweet option that provides potassium for heart health. Easy to digest and comforting during recovery when appetite is low but nutrition is crucial.",
                ingredients: [
                    "1 ripe banana",
                    "1/4 cup Greek yogurt",
                    "1 tbsp milk",
                    "1/2 tsp vanilla extract",
                    "Cinnamon to taste"
                ],
                instructions: [
                    "Peel and slice banana",
                    "Mash banana with fork until smooth",
                    "Mix in Greek yogurt",
                    "Add milk and vanilla",
                    "Blend until creamy",
                    "Sprinkle with cinnamon"
                ]
            },
            {
                id: 39,
                title: "Plain Greek Yogurt with Honey",
                mealType: "breakfast",
                prepTime: "quick",
                servings: 1,
                protein: 15,
                calories: 140,
                carbs: 16,
                mainIngredient: "yogurt",
                description: "Simplest high-protein option with probiotics for gut health. Raw honey provides natural enzymes, while the smooth texture requires no preparation and is gentle on healing stomachs.",
                ingredients: [
                    "3/4 cup Greek yogurt, plain",
                    "1 tbsp honey",
                    "1/2 tsp vanilla extract (optional)"
                ],
                instructions: [
                    "Place Greek yogurt in bowl",
                    "Drizzle honey over yogurt",
                    "Add vanilla if desired",
                    "Stir until completely smooth",
                    "Serve immediately"
                ]
            },
            {
                id: 40,
                title: "Instant Mashed Potato Protein Bowl",
                mealType: "dinner",
                prepTime: "quick",
                servings: 1,
                protein: 18,
                calories: 155,
                carbs: 14,
                mainIngredient: "protein-powder",
                description: "Comfort food made nutritious with added protein powder. Familiar texture and taste provide psychological comfort while delivering complete nutrition in an easily digestible form.",
                ingredients: [
                    "1/4 cup instant mashed potato flakes",
                    "1 scoop unflavored protein powder",
                    "1/2 cup warm milk",
                    "1 tbsp butter",
                    "Salt to taste"
                ],
                instructions: [
                    "Mix protein powder with potato flakes",
                    "Gradually add warm milk while stirring",
                    "Add butter and salt",
                    "Stir until completely smooth",
                    "Let sit 2 minutes to thicken",
                    "Serve warm"
                ]
            },
            {
                id: 41,
                title: "Simple Applesauce with Protein",
                mealType: "snack",
                prepTime: "quick",
                servings: 1,
                protein: 12,
                calories: 110,
                carbs: 18,
                mainIngredient: "protein-powder",
                description: "Gentle on sensitive stomachs with natural fruit sweetness. Applesauce provides pectin for digestive health, while added protein ensures adequate intake for healing and muscle preservation.",
                ingredients: [
                    "1/2 cup unsweetened applesauce",
                    "1/2 scoop vanilla protein powder",
                    "1 tbsp Greek yogurt",
                    "Cinnamon to taste"
                ],
                instructions: [
                    "Place applesauce in bowl",
                    "Gradually whisk in protein powder",
                    "Add Greek yogurt",
                    "Mix until completely smooth",
                    "Sprinkle with cinnamon",
                    "Serve chilled or at room temperature"
                ]
            },
            {
                id: 42,
                title: "Basic Cream of Wheat with Protein",
                mealType: "breakfast",
                prepTime: "quick",
                servings: 1,
                protein: 16,
                calories: 165,
                carbs: 20,
                mainIngredient: "protein-powder",
                description: "Warm, comforting breakfast that's easy to digest and absorb. Iron-fortified cream of wheat supports blood health, while protein powder transforms a simple grain into complete nutrition.",
                ingredients: [
                    "3 tbsp instant cream of wheat",
                    "1/2 scoop vanilla protein powder",
                    "3/4 cup milk",
                    "1 tsp honey",
                    "Pinch of salt"
                ],
                instructions: [
                    "Heat milk in microwave or stovetop",
                    "Stir in cream of wheat gradually",
                    "Cook according to package directions",
                    "Let cool slightly, then whisk in protein powder",
                    "Add honey and salt",
                    "Serve warm"
                ]
            },
            {
                id: 43,
                title: "Simple Cheese Sauce Puree",
                mealType: "lunch",
                prepTime: "quick",
                servings: 2,
                protein: 14,
                calories: 145,
                carbs: 4,
                mainIngredient: "cottage-cheese",
                description: "Comfort food that satisfies cheese cravings while providing calcium for bone health. Smooth, creamy texture is soothing and familiar, helping with the psychological adjustment to puree foods.",
                ingredients: [
                    "1/2 cup cottage cheese",
                    "1/4 cup shredded cheddar cheese",
                    "3 tbsp milk",
                    "1/4 tsp garlic powder",
                    "Salt and pepper"
                ],
                instructions: [
                    "Place cottage cheese in blender",
                    "Add cheddar cheese and milk",
                    "Blend until completely smooth",
                    "Add seasonings",
                    "Warm gently if desired",
                    "Serve immediately"
                ]
            },
            {
                id: 44,
                title: "Sweet Potato Breakfast Mash",
                mealType: "breakfast",
                prepTime: "medium",
                servings: 2,
                protein: 10,
                calories: 145,
                carbs: 26,
                mainIngredient: "sweet-potato",
                description: "Beta-carotene rich morning fuel that provides sustained energy. Natural sweetness satisfies morning cravings while fiber supports digestive health during recovery.",
                ingredients: [
                    "1 medium baked sweet potato",
                    "1/4 cup Greek yogurt",
                    "1 tbsp almond butter",
                    "1 tsp cinnamon",
                    "1 tbsp maple syrup",
                    "2 tbsp milk"
                ],
                instructions: [
                    "Bake sweet potato until very tender",
                    "Remove skin and mash flesh",
                    "Mix in Greek yogurt and almond butter",
                    "Add cinnamon and maple syrup",
                    "Thin with milk to desired consistency",
                    "Serve warm"
                ]
            },
            {
                id: 45,
                title: "Tofu Scramble Breakfast Puree",
                mealType: "breakfast",
                prepTime: "medium",
                servings: 2,
                protein: 16,
                calories: 135,
                carbs: 6,
                mainIngredient: "tofu",
                description: "Plant-based breakfast protein with complete amino acids. Turmeric provides anti-inflammatory benefits while creating familiar scrambled egg appearance and comfort.",
                ingredients: [
                    "6 oz silken tofu",
                    "1 tbsp nutritional yeast",
                    "1/2 tsp turmeric",
                    "1 tbsp olive oil",
                    "1/4 tsp garlic powder",
                    "2 tbsp vegetable broth",
                    "Salt and pepper"
                ],
                instructions: [
                    "Crumble tofu and sauté in olive oil",
                    "Add turmeric and garlic powder",
                    "Cook until heated through",
                    "Transfer to blender with broth",
                    "Add nutritional yeast",
                    "Blend until smooth",
                    "Season to taste"
                ]
            },
            {
                id: 46,
                title: "Berry Avocado Smoothie Bowl",
                mealType: "snack",
                prepTime: "quick",
                servings: 1,
                protein: 8,
                calories: 165,
                carbs: 18,
                mainIngredient: "berries",
                description: "Antioxidant powerhouse with healthy fats for satiety. Berries provide vitamin C for healing while avocado creates creamy texture and provides heart-healthy monounsaturated fats.",
                ingredients: [
                    "1/2 cup mixed berries",
                    "1/4 ripe avocado",
                    "1/2 cup unsweetened almond milk",
                    "1 tbsp honey",
                    "1 tsp lime juice",
                    "1/4 cup Greek yogurt"
                ],
                instructions: [
                    "Combine berries and avocado in blender",
                    "Add almond milk and honey",
                    "Add lime juice and Greek yogurt",
                    "Blend until completely smooth",
                    "Adjust sweetness if needed",
                    "Serve immediately"
                ]
            },
            {
                id: 47,
                title: "Beef & Sweet Potato Dinner Puree",
                mealType: "dinner",
                prepTime: "medium",
                servings: 4,
                protein: 22,
                calories: 175,
                carbs: 14,
                mainIngredient: "beef",
                description: "Iron-rich combination perfect for preventing post-surgery anemia. Sweet potato provides complex carbohydrates for sustained energy while beef delivers complete protein for muscle maintenance.",
                ingredients: [
                    "4 oz lean ground beef",
                    "1/2 cup cooked sweet potato",
                    "3 tbsp beef broth",
                    "1 tbsp olive oil",
                    "1/2 tsp thyme",
                    "1/4 tsp garlic powder",
                    "Salt and pepper"
                ],
                instructions: [
                    "Brown ground beef thoroughly",
                    "Steam sweet potato until very soft",
                    "Combine beef and sweet potato in processor",
                    "Add broth and seasonings",
                    "Process until completely smooth",
                    "Adjust consistency with more broth",
                    "Serve warm"
                ]
            },
            {
                id: 48,
                title: "Spinach & Cottage Cheese Breakfast",
                mealType: "breakfast",
                prepTime: "quick",
                servings: 1,
                protein: 18,
                calories: 125,
                carbs: 6,
                mainIngredient: "spinach",
                description: "Nutrient-dense morning meal packed with iron and folate. Spinach provides essential nutrients for energy metabolism while cottage cheese delivers sustained protein for morning fuel.",
                ingredients: [
                    "1 cup fresh spinach",
                    "1/2 cup cottage cheese",
                    "2 tbsp milk",
                    "1 tbsp cream cheese",
                    "1/4 tsp garlic powder",
                    "Salt and pepper"
                ],
                instructions: [
                    "Steam spinach until wilted",
                    "Squeeze out excess water",
                    "Combine spinach and cottage cheese in blender",
                    "Add milk and cream cheese",
                    "Season with garlic powder",
                    "Blend until smooth",
                    "Serve at room temperature"
                ]
            },
            {
                id: 49,
                title: "Fish & Spinach Power Lunch",
                mealType: "lunch",
                prepTime: "medium",
                servings: 2,
                protein: 24,
                calories: 145,
                carbs: 4,
                mainIngredient: "fish",
                description: "Double dose of iron from fish and spinach helps combat post-surgery anemia. Omega-3s support brain health and reduce inflammation during healing process.",
                ingredients: [
                    "4 oz cooked white fish",
                    "1 cup cooked spinach",
                    "2 tbsp Greek yogurt",
                    "1 tbsp lemon juice",
                    "1 tsp olive oil",
                    "1/4 tsp dill",
                    "Salt and pepper"
                ],
                instructions: [
                    "Cook fish until flaky",
                    "Steam spinach and squeeze dry",
                    "Combine fish and spinach in processor",
                    "Add yogurt, lemon juice, and oil",
                    "Season with dill",
                    "Process until smooth",
                    "Adjust consistency as needed"
                ]
            },
            {
                id: 50,
                title: "Turkey & Spinach Breakfast Hash",
                mealType: "breakfast",
                prepTime: "medium",
                servings: 2,
                protein: 20,
                calories: 155,
                carbs: 5,
                mainIngredient: "turkey",
                description: "Savory breakfast option high in protein and iron. Turkey provides lean protein for muscle maintenance while spinach delivers folate essential for cell regeneration during recovery.",
                ingredients: [
                    "3 oz cooked ground turkey",
                    "1 cup cooked spinach",
                    "2 tbsp turkey broth",
                    "1 tbsp cream cheese",
                    "1/2 tsp sage",
                    "1/4 tsp black pepper",
                    "Salt to taste"
                ],
                instructions: [
                    "Cook ground turkey thoroughly",
                    "Steam spinach until very soft",
                    "Combine turkey and spinach in processor",
                    "Add broth and cream cheese",
                    "Season with sage and pepper",
                    "Process until completely smooth",
                    "Serve warm"
                ]
            },
            {
                id: 51,
                title: "Banana Cottage Cheese Pancake Puree",
                mealType: "breakfast",
                prepTime: "medium",
                servings: 2,
                protein: 19,
                calories: 165,
                carbs: 18,
                mainIngredient: "banana",
                description: "Comfort food breakfast that satisfies pancake cravings without excess carbs. Natural banana sweetness eliminates need for added sugars while providing potassium for heart health.",
                ingredients: [
                    "1 ripe banana",
                    "1/2 cup cottage cheese",
                    "1 large egg",
                    "1 tbsp oat flour",
                    "1 tsp vanilla",
                    "Cinnamon",
                    "Cooking spray"
                ],
                instructions: [
                    "Mash banana until smooth",
                    "Mix with cottage cheese and egg",
                    "Add oat flour and vanilla",
                    "Cook small pancakes in pan",
                    "Let cool, then puree pancakes",
                    "Add milk if needed for consistency",
                    "Serve with cinnamon"
                ]
            }
        ];

        function renderRecipes(recipesToRender) {
            const container = document.getElementById('bariatricRecipesContainer');
            
            if (recipesToRender.length === 0) {
                container.innerHTML = '<div class="bariatric-no-results">No recipes found matching your criteria.</div>';
                return;
            }
            
            container.innerHTML = recipesToRender.map(recipe => `
                <div class="bariatric-recipe-card">
                    <div class="bariatric-recipe-header">
                        <div class="bariatric-recipe-title">${recipe.title}</div>
                        <div class="bariatric-recipe-meta">
                            <span class="bariatric-meal-type">${recipe.mealType}</span>
                            <span>${recipe.prepTime === 'quick' ? 'Under 15 min' : '15-30 min'}</span>
                        </div>
                    </div>
                    <div class="bariatric-recipe-content">
                        <div class="bariatric-recipe-description">
                            <strong>Why it's perfect for puree stage:</strong> ${recipe.description}
                        </div>
                        
                        <div class="bariatric-nutrition-info">
                            <div class="bariatric-nutrition-item">
                                <span class="bariatric-nutrition-value">${recipe.protein}g</span>
                                <span class="bariatric-nutrition-label">Protein</span>
                            </div>
                            <div class="bariatric-nutrition-item">
                                <span class="bariatric-nutrition-value">${recipe.calories}</span>
                                <span class="bariatric-nutrition-label">Calories</span>
                            </div>
                            <div class="bariatric-nutrition-item">
                                <span class="bariatric-nutrition-value">${recipe.carbs}g</span>
                                <span class="bariatric-nutrition-label">Carbs</span>
                            </div>
                        </div>
                        
                        <div class="bariatric-ingredients">
                            <h4>Ingredients (${recipe.servings} servings):</h4>
                            <ul>
                                ${recipe.ingredients.map(ingredient => `<li>${ingredient}</li>`).join('')}
                            </ul>
                        </div>
                        
                        <div class="bariatric-instructions">
                            <h4>Instructions:</h4>
                            <ol>
                                ${recipe.instructions.map(instruction => `<li>${instruction}</li>`).join('')}
                            </ol>
                        </div>
                    </div>
                </div>
            `).join('');
        }

        function filterRecipes() {
            const mealType = document.getElementById('bariatricMealType').value;
            const prepTime = document.getElementById('bariatricPrepTime').value;
            const mainIngredient = document.getElementById('bariatricMainIngredient').value;
            const searchTerm = document.getElementById('bariatricSearchBox').value.toLowerCase();
            
            let filtered = bariatricRecipes.filter(recipe => {
                const matchesMealType = !mealType || recipe.mealType === mealType;
                const matchesPrepTime = !prepTime || recipe.prepTime === prepTime;
                const matchesIngredient = !mainIngredient || recipe.mainIngredient === mainIngredient;
                
                const matchesSearch = !searchTerm || 
                    recipe.title.toLowerCase().includes(searchTerm) ||
                    recipe.ingredients.some(ingredient => ingredient.toLowerCase().includes(searchTerm));
                
                return matchesMealType && matchesPrepTime && matchesIngredient && matchesSearch;
            });
            
            renderRecipes(filtered);
        }

        // Event listeners
        document.getElementById('bariatricMealType').addEventListener('change', filterRecipes);
        document.getElementById('bariatricPrepTime').addEventListener('change', filterRecipes);
        document.getElementById('bariatricMainIngredient').addEventListener('change', filterRecipes);
        document.getElementById('bariatricSearchBox').addEventListener('input', filterRecipes);

        // Initial render
        renderRecipes(bariatricRecipes);